import appStore from './stores/AppStore';
import authStore from './stores/AuthStore';
import searchStore from './stores/SearchPage/SearchResultsStore';
import filterStore from './stores/SearchPage/SearchFiltersStore';
import carsStore from './stores/MyVehiclesListStore';
import carStore from './stores/VehicleDetailsStore';
import carAddStore from './stores/VehicleAddStore';
import checkoutStore from './stores/CheckoutStore';
import compareStore from './stores/CompareStore';
import carEditStore from './stores/VehicleEditStore';
import favoriteStore from './stores/FavoriteStore';
import imagesStore from './stores/ImagesStore';
import invoicesStore from './stores/InvoicesStore';
import profileStore from './stores/ProfileStore';
import dealerProfileStore from './stores/DealerProfileStore';
import notificationStore from './stores/NotificationStore';
import financingStore from './stores/FinancingStore';
import imagePackagesStore from './stores/ImagePackagesStore';
import exportConfigsStore from './stores/ExportConfigsStore';
import exportConfigEditorStore from './stores/ExportConfigEditorStore';
import notFoundStore from './stores/NotFoundStore';
import recentlyStore from './stores/RecentlyStore';
export default {
    appStore,
    authStore,
    searchStore,
    carsStore,
    carStore,
    carAddStore,
    carEditStore,
    profileStore,
    filterStore,
    compareStore,
    checkoutStore,
    favoriteStore,
    imagesStore,
    invoicesStore,
    dealerProfileStore,
    notificationStore,
    financingStore,
    imagePackagesStore,
    exportConfigsStore,
    exportConfigEditorStore,
    notFoundStore,
    recentlyStore
};
